export default {
  Loading: 'Caricamento...',
  search: 'Cerca...',
  noMessages: 'Nessun messaggio',
  noSearchResults: 'Nessun record corrispondente',
};
